import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { LevelBadge } from "./levelBadge";

interface LevelBadgeState {
  level: LevelBadge;
}

const initialState: LevelBadgeState = {
  level: LevelBadge.sprout,
};

export const levelBadgeSlice = createSlice({
  name: "levelBadgeSlice",
  initialState,
  reducers: {
    updateLevel: (state, action: PayloadAction<any>) => {
      state.level = action.payload;
    },
  },
});

export const { updateLevel } = levelBadgeSlice.actions;
export const selectLevel = (state: RootState) => state.level.level;
